module.exports = __webpack_public_path__ + "img/5.450de8ec.jpg";